import { styled } from '@mui/material/styles';
import { Typography } from '@raisin/components-lib';

export const ProductContent = styled('div')(({ theme }) => ({
  width: '100%',
  border: `1px solid ${theme.palette.grey200.main}`,
  borderRadius: theme.spacing(2),
  padding: theme.spacing(4),

  [theme.breakpoints.up('md')]: {
    maxWidth: 562,
  },
}));

export const ProductDetails = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(6),
  width: '100%',
  marginTop: theme.spacing(2),
  alignItems: 'end',

  [theme.breakpoints.down('sm')]: {
    alignItems: 'center',
  },
}));

export const Row = styled('div')({
  width: 160,
});

export const RowTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  color: theme.palette.grey700.main,
}));

export const DefaultRate = styled(Typography)(({ theme }) => ({
  color: theme.palette.blue600.main,

  span: {
    ...theme.typography.body1,
  },

  [theme.breakpoints.down('sm')]: {
    ...theme.typography.h3,
  },
}));

export const ProductItem = styled('div')(({ theme, $isLongText }) => ({
  width: 160,
  display: 'flex',
  alignItems: 'baseline',
  flexDirection: 'column',

  [theme.breakpoints.down('sm')]: {
    display: $isLongText ? 'none' : 'block',

    '&:last-child': {
      marginLeft: 'auto',
    },
  },

  [theme.breakpoints.between('md', 'lg')]: {
    display: $isLongText ? 'none' : 'block',

    '&:last-child': {
      marginLeft: 'auto',
    },
  },
}));

export const ProductItemRow = styled('div')(({ theme, $isLongText }) => ({
  display: 'none',

  [theme.breakpoints.down('sm')]: {
    display: $isLongText ? 'block' : 'none',
    margin: theme.spacing(2, 0, 0),
  },

  [theme.breakpoints.between('md', 'lg')]: {
    display: $isLongText ? 'block' : 'none',
    margin: theme.spacing(2, 0, 0),
  },
}));
